<template>
  <lazy-div :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="100%" class="mavSmallMenu">
            <v-toolbar flat>
              <v-list>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="subheading" v-if="!newBusCls">
                      {{ busClsTitle }}
                    </v-list-tile-title>
                    <v-list-tile-title class="subheading" v-else>
                      New Business Class
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-toolbar>
            <v-list class="pt-0">
              <v-divider></v-divider>
              <v-list-tile key="fireBusClsGeneral" :to="{ name: 'fireBusClsGeneral', params: { id: id } }">
                <v-list-tile-action>
                  <v-icon></v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>General</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-group v-if="!newBusCls">
                <v-list-tile slot="activator">
                  <v-list-tile-action>
                    <v-icon></v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Claim</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-for="item in claimMenu" :key="item.name" :to="{ name: item.name }">
                  <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-group>
              <template v-if="!newBusCls">
                <v-list-tile v-for="item in sideMenu" :key="item.name" :to="{ name: item.name }">
                  <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
          </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view @resetSideMenu="resetSideMenu"></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </lazy-div>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { appID } from '@/const/underwriting'
import { PARAMETERS_APPID } from '@/store/types'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      sideMenu: [
        { name: 'fireProdBusCls', text: 'Product', icon: '' }
      ],
      claimMenu: [
        { name: 'fireBusClsClmNol1', text: 'Nature of Loss', icon: '' },
        { name: 'fireBusClsClmResCat', text: 'Reserve Category', icon: '' }
      ],
      covers: [],
      coverMenu: [],
      tariff: [],
      tariffMenu: [],
      selectedCovers: [],
      newBusCls: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    busClsState() {
      return this.$store.state.parameters.busCls
    },
    busClsTitle() {
      return this.$store.state.parameters.busCls.busClsMenu.sideMenuTitle
    }
  },
  methods: {
    async doInit() {
      this.$store.commit(PARAMETERS_APPID, appID.FIRE)
      if (this.id === 'new') {
        this.newBusCls = true
      } else {
        await this.$store.dispatch('busClsMenuInit', this.id)
        this.coverMenu = this.coverList
        this.tariffMenu = this.tariffList
      }
    },
    async resetSideMenu() {
      await this.doInit()
    }
  },
  created() {
    if (this.id === 'new') {
      this.newBusCls = true
    }
  },
  mixins: [
    routeMixin,
    MessageMixin
  ],
  props: ['id']
}
</script>

<style lang="scss">
.queryPnl {
  margin-top: 50px;
}
</style>
